import { createElement, useMemo } from 'react';

import DOMPurify from 'dompurify';

type TSafeHTMLProps = {
    html: string;
    as?: keyof HTMLElementTagNameMap;
    className?: string;
    allowedTags?: string[];
    allowedAttributes?: string[];
} & Omit<
    React.HTMLAttributes<HTMLElement>,
    'dangerouslySetInnerHTML' | 'children'
>;

export const SafeHTML = ({
    html,
    as = 'div',
    className,
    allowedTags,
    allowedAttributes,
    ...props
}: TSafeHTMLProps) => {
    const sanitizedHTML = useMemo(() => {
        const config: DOMPurify.Config = {};

        if (allowedTags) {
            config.ALLOWED_TAGS = allowedTags;
        }
        if (allowedAttributes) {
            config.ALLOWED_ATTR = allowedAttributes;
        }

        return DOMPurify.sanitize(html, config);
    }, [html, allowedTags, allowedAttributes]);

    return createElement(as, {
        ...props,
        className,
        dangerouslySetInnerHTML: { __html: sanitizedHTML }
    });
};
